{
  "EmailNotifications": "Email Notifications",
  "NotificationDescription": "Send me notifications for:",
  "MyActivityUpdateTitle": "My Activity Updates",
  "MyActivityDescription": "Daily updates on comments, notes, or replies to my projects, posts or comments",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Monthly": "Monthly",
  "None": "None",
  "HubActivityTitle": "Hub Activity Updates",
  "HubActivityDescription": "Weekly summary on community activity happening in my hubs",
  "MarketingEmailTitle": "Marketing Emails",
  "MarketingEmailDescription": "RebelBase may send you emails to get your opinions with a survey or for other marketing purposes",
  "Yes": "Yes",
  "No": "No",
  "Save": "Save"
}
